// Bloque del Dashboard sin caja (el Dashboard es plano): un título grande con
// una línea de su color debajo y espacio por encima, para que se distinga de
// qué es cada grupo de números: creadores, agencias y gráficas.
//   accent  color del título y de la línea
export default function DashboardSection({ title, subtitle, accent = '#3b82f6', info = null, right = null, children }) {
  return (
    <section className="mt-4 flex flex-col gap-5 first:mt-0">
      <div className="flex flex-wrap items-end justify-between gap-2 border-b-2 pb-2" style={{ borderColor: accent }}>
        <div className="min-w-0">
          <div className="flex items-center gap-1.5">
            <h2 className="text-lg font-semibold leading-tight" style={{ color: accent }}>{title}</h2>
            {info}
          </div>
          {subtitle && <p className="text-xs text-default-500">{subtitle}</p>}
        </div>
        {right}
      </div>
      {children}
    </section>
  );
}
